/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { ApiUserManagementCreatePostRequest } from "../models";
// @ts-ignore
import { UserManagementModel } from "../models";
// @ts-ignore
import { UserManagementModelODataResultCollection } from "../models";
/**
 * UserManagementApi - axios parameter creator
 * @export
 */
export const UserManagementApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {ApiUserManagementCreatePostRequest} [apiUserManagementCreatePostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementCreatePost: async (
      apiUserManagementCreatePostRequest?: ApiUserManagementCreatePostRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserManagement/Create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiUserManagementCreatePostRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} cardCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementDeleteIdDelete: async (
      id: string,
      cardCode: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiUserManagementDeleteIdDelete", "id", id);
      // verify required parameter 'cardCode' is not null or undefined
      assertParamExists(
        "apiUserManagementDeleteIdDelete",
        "cardCode",
        cardCode
      );
      const localVarPath = `/api/UserManagement/Delete/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (cardCode !== undefined) {
        localVarQueryParameter["cardCode"] = cardCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ApiUserManagementCreatePostRequest} [apiUserManagementCreatePostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementEditPost: async (
      apiUserManagementCreatePostRequest?: ApiUserManagementCreatePostRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserManagement/Edit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiUserManagementCreatePostRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} email
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementEmailEmailGet: async (
      email: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'email' is not null or undefined
      assertParamExists("apiUserManagementEmailEmailGet", "email", email);
      const localVarPath = `/api/UserManagement/Email/{email}`.replace(
        `{${"email"}}`,
        encodeURIComponent(String(email))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Gets the list of customer user/cardcode.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementGet: async (
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserManagement`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Gets the list of customer permissions.
     * @param {string} cardCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementPermissionsGet: async (
      cardCode: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'cardCode' is not null or undefined
      assertParamExists(
        "apiUserManagementPermissionsGet",
        "cardCode",
        cardCode
      );
      const localVarPath = `/api/UserManagement/Permissions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (cardCode !== undefined) {
        localVarQueryParameter["cardCode"] = cardCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} cardCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementReInviteIdPost: async (
      id: string,
      cardCode: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("apiUserManagementReInviteIdPost", "id", id);
      // verify required parameter 'cardCode' is not null or undefined
      assertParamExists(
        "apiUserManagementReInviteIdPost",
        "cardCode",
        cardCode
      );
      const localVarPath = `/api/UserManagement/ReInvite/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (cardCode !== undefined) {
        localVarQueryParameter["cardCode"] = cardCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} userId
     * @param {string} cardCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementUserIdDeleteCardCodeCardCodeDelete: async (
      userId: string,
      cardCode: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists(
        "apiUserManagementUserIdDeleteCardCodeCardCodeDelete",
        "userId",
        userId
      );
      // verify required parameter 'cardCode' is not null or undefined
      assertParamExists(
        "apiUserManagementUserIdDeleteCardCodeCardCodeDelete",
        "cardCode",
        cardCode
      );
      const localVarPath =
        `/api/UserManagement/{userId}/DeleteCardCode/{cardCode}`
          .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
          .replace(`{${"cardCode"}}`, encodeURIComponent(String(cardCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} userId
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementUserIdGet: async (
      userId: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("apiUserManagementUserIdGet", "userId", userId);
      const localVarPath = `/api/UserManagement/{userId}`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserManagementApi - functional programming interface
 * @export
 */
export const UserManagementApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UserManagementApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {ApiUserManagementCreatePostRequest} [apiUserManagementCreatePostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserManagementCreatePost(
      apiUserManagementCreatePostRequest?: ApiUserManagementCreatePostRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UserManagementModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserManagementCreatePost(
          apiUserManagementCreatePostRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} id
     * @param {string} cardCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserManagementDeleteIdDelete(
      id: string,
      cardCode: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserManagementDeleteIdDelete(
          id,
          cardCode,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {ApiUserManagementCreatePostRequest} [apiUserManagementCreatePostRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserManagementEditPost(
      apiUserManagementCreatePostRequest?: ApiUserManagementCreatePostRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UserManagementModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserManagementEditPost(
          apiUserManagementCreatePostRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} email
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserManagementEmailEmailGet(
      email: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UserManagementModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserManagementEmailEmailGet(
          email,
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Gets the list of customer user/cardcode.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserManagementGet(
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UserManagementModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserManagementGet(
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Gets the list of customer permissions.
     * @param {string} cardCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserManagementPermissionsGet(
      cardCode: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserManagementPermissionsGet(
          cardCode,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} id
     * @param {string} cardCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserManagementReInviteIdPost(
      id: string,
      cardCode: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserManagementReInviteIdPost(
          id,
          cardCode,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} userId
     * @param {string} cardCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserManagementUserIdDeleteCardCodeCardCodeDelete(
      userId: string,
      cardCode: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserManagementUserIdDeleteCardCodeCardCodeDelete(
          userId,
          cardCode,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} userId
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserManagementUserIdGet(
      userId: string,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<UserManagementModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserManagementUserIdGet(
          userId,
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * UserManagementApi - factory interface
 * @export
 */
export const UserManagementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserManagementApiFp(configuration);
  return {
    /**
     *
     * @param {UserManagementApiApiUserManagementCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementCreatePost(
      requestParameters: UserManagementApiApiUserManagementCreatePostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<UserManagementModel> {
      return localVarFp
        .apiUserManagementCreatePost(
          requestParameters.apiUserManagementCreatePostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UserManagementApiApiUserManagementDeleteIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementDeleteIdDelete(
      requestParameters: UserManagementApiApiUserManagementDeleteIdDeleteRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiUserManagementDeleteIdDelete(
          requestParameters.id,
          requestParameters.cardCode,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UserManagementApiApiUserManagementEditPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementEditPost(
      requestParameters: UserManagementApiApiUserManagementEditPostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<UserManagementModel> {
      return localVarFp
        .apiUserManagementEditPost(
          requestParameters.apiUserManagementCreatePostRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UserManagementApiApiUserManagementEmailEmailGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementEmailEmailGet(
      requestParameters: UserManagementApiApiUserManagementEmailEmailGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<UserManagementModelODataResultCollection> {
      return localVarFp
        .apiUserManagementEmailEmailGet(
          requestParameters.email,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Gets the list of customer user/cardcode.
     * @param {UserManagementApiApiUserManagementGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementGet(
      requestParameters: UserManagementApiApiUserManagementGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<UserManagementModelODataResultCollection> {
      return localVarFp
        .apiUserManagementGet(
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Gets the list of customer permissions.
     * @param {UserManagementApiApiUserManagementPermissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementPermissionsGet(
      requestParameters: UserManagementApiApiUserManagementPermissionsGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Array<string>> {
      return localVarFp
        .apiUserManagementPermissionsGet(requestParameters.cardCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UserManagementApiApiUserManagementReInviteIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementReInviteIdPost(
      requestParameters: UserManagementApiApiUserManagementReInviteIdPostRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiUserManagementReInviteIdPost(
          requestParameters.id,
          requestParameters.cardCode,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UserManagementApiApiUserManagementUserIdDeleteCardCodeCardCodeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementUserIdDeleteCardCodeCardCodeDelete(
      requestParameters: UserManagementApiApiUserManagementUserIdDeleteCardCodeCardCodeDeleteRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiUserManagementUserIdDeleteCardCodeCardCodeDelete(
          requestParameters.userId,
          requestParameters.cardCode,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UserManagementApiApiUserManagementUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserManagementUserIdGet(
      requestParameters: UserManagementApiApiUserManagementUserIdGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<UserManagementModelODataResultCollection> {
      return localVarFp
        .apiUserManagementUserIdGet(
          requestParameters.userId,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for apiUserManagementCreatePost operation in UserManagementApi.
 * @export
 * @interface UserManagementApiApiUserManagementCreatePostRequest
 */
export interface UserManagementApiApiUserManagementCreatePostRequest {
  /**
   *
   * @type {ApiUserManagementCreatePostRequest}
   * @memberof UserManagementApiApiUserManagementCreatePost
   */
  readonly apiUserManagementCreatePostRequest?: ApiUserManagementCreatePostRequest;
}

/**
 * Request parameters for apiUserManagementDeleteIdDelete operation in UserManagementApi.
 * @export
 * @interface UserManagementApiApiUserManagementDeleteIdDeleteRequest
 */
export interface UserManagementApiApiUserManagementDeleteIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof UserManagementApiApiUserManagementDeleteIdDelete
   */
  readonly id: string;

  /**
   *
   * @type {string}
   * @memberof UserManagementApiApiUserManagementDeleteIdDelete
   */
  readonly cardCode: string;
}

/**
 * Request parameters for apiUserManagementEditPost operation in UserManagementApi.
 * @export
 * @interface UserManagementApiApiUserManagementEditPostRequest
 */
export interface UserManagementApiApiUserManagementEditPostRequest {
  /**
   *
   * @type {ApiUserManagementCreatePostRequest}
   * @memberof UserManagementApiApiUserManagementEditPost
   */
  readonly apiUserManagementCreatePostRequest?: ApiUserManagementCreatePostRequest;
}

/**
 * Request parameters for apiUserManagementEmailEmailGet operation in UserManagementApi.
 * @export
 * @interface UserManagementApiApiUserManagementEmailEmailGetRequest
 */
export interface UserManagementApiApiUserManagementEmailEmailGetRequest {
  /**
   *
   * @type {string}
   * @memberof UserManagementApiApiUserManagementEmailEmailGet
   */
  readonly email: string;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof UserManagementApiApiUserManagementEmailEmailGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof UserManagementApiApiUserManagementEmailEmailGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof UserManagementApiApiUserManagementEmailEmailGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof UserManagementApiApiUserManagementEmailEmailGet
   */
  readonly $orderby?: string;
}

/**
 * Request parameters for apiUserManagementGet operation in UserManagementApi.
 * @export
 * @interface UserManagementApiApiUserManagementGetRequest
 */
export interface UserManagementApiApiUserManagementGetRequest {
  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof UserManagementApiApiUserManagementGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof UserManagementApiApiUserManagementGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof UserManagementApiApiUserManagementGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof UserManagementApiApiUserManagementGet
   */
  readonly $orderby?: string;
}

/**
 * Request parameters for apiUserManagementPermissionsGet operation in UserManagementApi.
 * @export
 * @interface UserManagementApiApiUserManagementPermissionsGetRequest
 */
export interface UserManagementApiApiUserManagementPermissionsGetRequest {
  /**
   *
   * @type {string}
   * @memberof UserManagementApiApiUserManagementPermissionsGet
   */
  readonly cardCode: string;
}

/**
 * Request parameters for apiUserManagementReInviteIdPost operation in UserManagementApi.
 * @export
 * @interface UserManagementApiApiUserManagementReInviteIdPostRequest
 */
export interface UserManagementApiApiUserManagementReInviteIdPostRequest {
  /**
   *
   * @type {string}
   * @memberof UserManagementApiApiUserManagementReInviteIdPost
   */
  readonly id: string;

  /**
   *
   * @type {string}
   * @memberof UserManagementApiApiUserManagementReInviteIdPost
   */
  readonly cardCode: string;
}

/**
 * Request parameters for apiUserManagementUserIdDeleteCardCodeCardCodeDelete operation in UserManagementApi.
 * @export
 * @interface UserManagementApiApiUserManagementUserIdDeleteCardCodeCardCodeDeleteRequest
 */
export interface UserManagementApiApiUserManagementUserIdDeleteCardCodeCardCodeDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof UserManagementApiApiUserManagementUserIdDeleteCardCodeCardCodeDelete
   */
  readonly userId: string;

  /**
   *
   * @type {string}
   * @memberof UserManagementApiApiUserManagementUserIdDeleteCardCodeCardCodeDelete
   */
  readonly cardCode: string;
}

/**
 * Request parameters for apiUserManagementUserIdGet operation in UserManagementApi.
 * @export
 * @interface UserManagementApiApiUserManagementUserIdGetRequest
 */
export interface UserManagementApiApiUserManagementUserIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof UserManagementApiApiUserManagementUserIdGet
   */
  readonly userId: string;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof UserManagementApiApiUserManagementUserIdGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof UserManagementApiApiUserManagementUserIdGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof UserManagementApiApiUserManagementUserIdGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof UserManagementApiApiUserManagementUserIdGet
   */
  readonly $orderby?: string;
}

/**
 * UserManagementApi - object-oriented interface
 * @export
 * @class UserManagementApi
 * @extends {BaseAPI}
 */
export class UserManagementApi extends BaseAPI {
  /**
   *
   * @param {UserManagementApiApiUserManagementCreatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserManagementApi
   */
  public apiUserManagementCreatePost(
    requestParameters: UserManagementApiApiUserManagementCreatePostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return UserManagementApiFp(this.configuration)
      .apiUserManagementCreatePost(
        requestParameters.apiUserManagementCreatePostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserManagementApiApiUserManagementDeleteIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserManagementApi
   */
  public apiUserManagementDeleteIdDelete(
    requestParameters: UserManagementApiApiUserManagementDeleteIdDeleteRequest,
    options?: AxiosRequestConfig
  ) {
    return UserManagementApiFp(this.configuration)
      .apiUserManagementDeleteIdDelete(
        requestParameters.id,
        requestParameters.cardCode,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserManagementApiApiUserManagementEditPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserManagementApi
   */
  public apiUserManagementEditPost(
    requestParameters: UserManagementApiApiUserManagementEditPostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return UserManagementApiFp(this.configuration)
      .apiUserManagementEditPost(
        requestParameters.apiUserManagementCreatePostRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserManagementApiApiUserManagementEmailEmailGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserManagementApi
   */
  public apiUserManagementEmailEmailGet(
    requestParameters: UserManagementApiApiUserManagementEmailEmailGetRequest,
    options?: AxiosRequestConfig
  ) {
    return UserManagementApiFp(this.configuration)
      .apiUserManagementEmailEmailGet(
        requestParameters.email,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Gets the list of customer user/cardcode.
   * @param {UserManagementApiApiUserManagementGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserManagementApi
   */
  public apiUserManagementGet(
    requestParameters: UserManagementApiApiUserManagementGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return UserManagementApiFp(this.configuration)
      .apiUserManagementGet(
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Gets the list of customer permissions.
   * @param {UserManagementApiApiUserManagementPermissionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserManagementApi
   */
  public apiUserManagementPermissionsGet(
    requestParameters: UserManagementApiApiUserManagementPermissionsGetRequest,
    options?: AxiosRequestConfig
  ) {
    return UserManagementApiFp(this.configuration)
      .apiUserManagementPermissionsGet(requestParameters.cardCode, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserManagementApiApiUserManagementReInviteIdPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserManagementApi
   */
  public apiUserManagementReInviteIdPost(
    requestParameters: UserManagementApiApiUserManagementReInviteIdPostRequest,
    options?: AxiosRequestConfig
  ) {
    return UserManagementApiFp(this.configuration)
      .apiUserManagementReInviteIdPost(
        requestParameters.id,
        requestParameters.cardCode,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserManagementApiApiUserManagementUserIdDeleteCardCodeCardCodeDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserManagementApi
   */
  public apiUserManagementUserIdDeleteCardCodeCardCodeDelete(
    requestParameters: UserManagementApiApiUserManagementUserIdDeleteCardCodeCardCodeDeleteRequest,
    options?: AxiosRequestConfig
  ) {
    return UserManagementApiFp(this.configuration)
      .apiUserManagementUserIdDeleteCardCodeCardCodeDelete(
        requestParameters.userId,
        requestParameters.cardCode,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UserManagementApiApiUserManagementUserIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserManagementApi
   */
  public apiUserManagementUserIdGet(
    requestParameters: UserManagementApiApiUserManagementUserIdGetRequest,
    options?: AxiosRequestConfig
  ) {
    return UserManagementApiFp(this.configuration)
      .apiUserManagementUserIdGet(
        requestParameters.userId,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
